<div class="dialog-wrapper">
  <app-dialog-header [title]="title" (closeDialog)="dialogRef.close()"></app-dialog-header>
  <div mat-dialog-content class="dialog-content pt-0">
    <div class="schedule-options">
      @if (isBackDated) {
      <div [class.margin-bottom]="isAssignedRole">
        <div class="spawn-warning">
          <div class="warning-icon-message">
            <lucide-icon [img]="TriangleAlert" [size]="20" class="expand-more"></lucide-icon>
            <span class="warning-header">Warning</span>
          </div>
          <div>
            You are about to reset a spawn schedule that started on {{reocurrence.startAt | date:
            'MM/dd/yyyy'}}.
          </div>
          <div>
            Do you want to spawn all {{isTaskSet ? 'task set' : 'task'}} instances before today
            {{now | date: 'MM/dd/yyyy'}}?
          </div>
        </div>

        <div class="relative block h-full choose-date">
          <mat-radio-group
            class="radio-group"
            [ngModel]="reocurrence.spawnPrevious"
            (ngModelChange)="reocurrence!.spawnPrevious = $event"
          >
            <mat-radio-button [value]="false">
              Only spawn future {{isTaskSet ? 'task sets' : 'tasks'}}
            </mat-radio-button>
            <mat-radio-button [value]="true">
              Spawn all {{isTaskSet ? 'task sets' : 'tasks'}} from the past`
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      } @if (isAssignedRole) {
      <div>
        <div class="dialog-description">
          Please select how you would like this task to be spawned:
        </div>
        <div class="relative block h-full choose-date">
          <mat-radio-group
            class="radio-group"
            [ngModel]="reocurrence.spawnMultiple"
            (ngModelChange)="reocurrence!.spawnMultiple = $event"
          >
            <mat-radio-button [value]="false">
              Allow anyone with the role {{profileName}} to complete this task
            </mat-radio-button>
            <mat-radio-button [value]="true">
              Require everyone with the {{profileName}} role to complete this task
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      }
    </div>
    <div class="dialog-actions">
      <app-new-action-button
        (actionCompleted)="dialogRef.close()"
        themedButton="secondary"
        text="Cancel"
      ></app-new-action-button>
      <app-new-action-button
        (actionCompleted)="onSave()"
        themedButton="primary"
        text="Save"
      ></app-new-action-button>
    </div>
  </div>
</div>
